import {node_observable_component} from 'common/util/ComponentDecorator';
import ObserverUtil from 'common/util/ObserverUtil';

@node_observable_component
export default class WaField {
    static classname = 'wa-field';

    constructor($field) {
        this.$field = $field;
        if (this.$field.closest('.form')) {
            this.decorateSubFields();
            this.init();
            this.bindEvents();
        }
    }

    init() {
        const $inputs = this.$field.find('.wa-value input');
        $inputs.each(function () {
            const $input = $(this);
            const $fieldBlock = $input.closest('.wa-field');
            let placeholder = $input.attr('placeholder');

            if (!placeholder) {
                placeholder = $fieldBlock.find('.wa-name').text().replace('*','');
            }

            if (placeholder !== 'Введите e-mail') {
                $input.attr('placeholder', '');
            }

            $(`<span class="custom-label">${placeholder}</span>`).insertAfter($input);
            if ($input.val() && $input.attr('type') !== 'password') {
                $fieldBlock.addClass('wa-field--hasvalue');
            }
            if ($input.hasClass('error')) {
                $fieldBlock.addClass('wa-field--error');
            }
        });
    }

    decorateSubFields() {
        var $fields = this.$field.find('.wa-value .field');

        if ($fields.length > 0) {
            $fields.each(function () {
                var $field = $(this);
                var $label = $field.children('span:not([class]):not([id])');

                $field.addClass('wa-field subfield');
                $label.addClass('custom-label');
            });
        }
    }

    bindEvents() {
        const $inputs = this.$field.find('.wa-value input');
        $inputs.each(function () {
            const $input = $(this);
            const $fieldBlock = $input.closest('.wa-field');
            const $customLabel = $fieldBlock.find('.custom-label');

            $input.on('input', () => {
                if ($input.val()) {
                    $fieldBlock.addClass('wa-field--hasvalue');
                } else {
                    $fieldBlock.removeClass('wa-field--hasvalue');
                }
            });

            if ($fieldBlock.hasClass('wa-field-onetime-password')) {
                $input.one('input', () => {
                    $fieldBlock.removeClass('wa-field--hasvalue');
                });
            }

            $input.on('focus', () => {
                $fieldBlock.removeClass('wa-field--error').addClass('wa-field--focused').find('.errormsg').remove();
            }).on('blur', () => {
                $fieldBlock.removeClass('wa-field--focused');
            });

            $input.on('mouseenter', () => {
                if ($fieldBlock.hasClass('wa-field--mask')) {
                    $fieldBlock.addClass('wa-field--hovered');
                }
            }).on('mouseout', () => {
                $fieldBlock.removeClass('wa-field--hovered');
            });
        });

        ObserverUtil.watchTag('INPUT');
        ObserverUtil.observeClass('wa-error', (node) => {
            let method = node.hasClass('wa-error') ? 'addClass' : 'removeClass';
            node.closest('.wa-field')[method]('wa-field--error');
        });
        ObserverUtil.observeClass('error', (node) => {
            let method = node.hasClass('error') ? 'addClass' : 'removeClass';
            node.closest('.wa-field.wa-required')[method]('wa-field--error');
        });

    }
}


